import React from 'react';
import classNames from 'classnames';
import { bool } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { CheckSolidIcon } from '@fiverr-private/icons';
import { green } from '@fiverr-private/sass/helpers';
import { selectSellerName, useStaticContext } from '../../../../context/contexts/static';
import { useOfferMoreGigsContext } from '../../../OfferMoreGigs/context';

const SentHeader = ({ disabled = false }) => {
    const context = useStaticContext();
    const { showMoreGigsStep } = useOfferMoreGigsContext();
    const username = selectSellerName(context);

    if (disabled || !showMoreGigsStep) {
        return null;
    }

    const wrapperClasses = classNames(
        'flex',
        'tbody-5',
        'flex-items-center'
    );

    return (
        <div className={wrapperClasses}
            data-testid="message-sent-header">
            <CheckSolidIcon color={green}/>
            <span className="m-l-8">
                <I18n k="send_message.message_sent.your_message_sent" params={{ username }}/>
            </span>
        </div>
    );
};

SentHeader.propTypes = {
    disabled: bool
};

export default SentHeader;
